var map = {
	"./add.svg": 4780,
	"./analysis-active.svg": 3428,
	"./analysis-report-active.svg": 4883,
	"./analysis-report.svg": 7114,
	"./analysis.svg": 7321,
	"./arch.svg": 6907,
	"./archive.svg": 2953,
	"./arroba-active.svg": 7460,
	"./arroba.svg": 8146,
	"./arrow-blue-down.svg": 6704,
	"./arrow-blue.svg": 9933,
	"./arrow-down.svg": 4746,
	"./bar-chart-blue.svg": 461,
	"./bar-chart-gray.svg": 4457,
	"./bills.svg": 4820,
	"./calendar.svg": 874,
	"./check-color.svg": 5875,
	"./check.svg": 706,
	"./checkbox.svg": 6369,
	"./circle-chart-blue.svg": 4052,
	"./circle-chart-gray.svg": 1377,
	"./close-eye.svg": 7928,
	"./close.svg": 420,
	"./copy-que.svg": 8037,
	"./copy.svg": 7918,
	"./cross-arrow.svg": 2810,
	"./date.svg": 3341,
	"./delete-img.svg": 2797,
	"./delete.svg": 2539,
	"./divider.svg": 5700,
	"./edit-active.svg": 7119,
	"./edit-black.svg": 6058,
	"./edit-blue-b.svg": 1946,
	"./edit-blue.svg": 4074,
	"./edit.svg": 8377,
	"./email-active.svg": 1385,
	"./email.svg": 7882,
	"./enlarge.svg": 9373,
	"./export.svg": 6707,
	"./form.svg": 5553,
	"./good-color.svg": 9878,
	"./good.svg": 6770,
	"./heart-color.svg": 8178,
	"./heart.svg": 3972,
	"./introduction.svg": 4863,
	"./list-copy.svg": 8976,
	"./list-sort.svg": 5775,
	"./lock.svg": 3914,
	"./logout.svg": 2990,
	"./loop-circular.svg": 2703,
	"./minus.svg": 4475,
	"./nest.svg": 8613,
	"./number.svg": 6499,
	"./open-eye.svg": 2354,
	"./permission-active.svg": 8581,
	"./permission.svg": 3740,
	"./plus.svg": 3189,
	"./preview.svg": 3196,
	"./publish.svg": 5370,
	"./radio.svg": 4236,
	"./range.svg": 6247,
	"./reply-active.svg": 4409,
	"./reply.svg": 1877,
	"./search.svg": 9262,
	"./sort.svg": 8475,
	"./star-color.svg": 9912,
	"./star.svg": 5360,
	"./stars.svg": 7129,
	"./text.svg": 6019,
	"./textarea.svg": 8625,
	"./tip.svg": 7538,
	"./upload-white.svg": 3424,
	"./upload.svg": 377,
	"./user-management-active.svg": 6969,
	"./user-management.svg": 1205,
	"./user.svg": 1816
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7254;